import { IconButton } from '@components/button/Button';
import { inputStyles, sizeStyle } from '@components/input/input.config';
import { InputSize } from 'types/input';

import theme from '../../../themes/colors';

interface NumberStepperProps {
  value: number;
  onChange: (value: number) => void;
  minValue: number;
  maxValue: number;
  className?: string;
  inputSize?: InputSize;
}

const NumberStepper = ({
  value,
  onChange,
  minValue,
  maxValue,
  className,
  inputSize = 'medium'
}: NumberStepperProps) => {
  const decrementDisabled = value === minValue;
  const incrementDisabled = value === maxValue;

  const handleDecrement = () => {
    onChange(value - 1);
  };
  const handleIncrement = () => {
    onChange(value + 1);
  };
  return (
    <div
      className={`${inputStyles.common} relative flex items-center justify-around rounded-lg px-4 py-2.5 ${sizeStyle[inputSize]} ${className}`}
    >
      <IconButton
        iconName="minus"
        variant="transparent"
        stroke={decrementDisabled ? theme.grey : theme.primary}
        size="none"
        className="!p-0"
        handleClick={handleDecrement}
        disabled={decrementDisabled}
      />
      <p>{value}</p>

      <IconButton
        iconName="plus"
        variant="transparent"
        stroke={incrementDisabled ? theme.grey : theme.primary}
        size="none"
        className="!p-0"
        handleClick={handleIncrement}
        disabled={incrementDisabled}
      />
    </div>
  );
};

export default NumberStepper;
